/**
 * Путь эндпоинта по сгенерированному контракту (ARCH-07a): адрес берётся из типа операции
 * `XxxData['url']` (`src/shared/api/generated`), поэтому переименование пути или удаление операции
 * в `shared/openapi/openapi.json` ломает type-check, а не запрос в рантайме.
 *
 * Пути контракта абсолютные (`/api/v1/admin/me`), а baseURL единого axios-инстанса уже указывает
 * на `/api/v1` (runtime-конфиг) — префикс отрезается; `{param}` заменяются значениями `path`.
 *
 *   endpoint<AdminAccMeGetData>('/api/v1/admin/me')                       → '/admin/me'
 *   endpoint<AdminCoreUploadsCompleteData>('/api/v1/admin/uploads/{upload_id}/complete',
 *     { upload_id })                                                      → '/admin/uploads/…/complete'
 */
export const CONTRACT_PREFIX = '/api/v1';

/** Параметры пути операции: есть `path` в `XxxData` — обязателен второй аргумент. */
export type EndpointPathArgs<TData> = TData extends { path: infer TPath } ? [path: TPath] : [];

const PLACEHOLDER = /\{([^}]+)\}/g;

export function endpoint<TData extends { url: string }>(
  url: TData['url'],
  ...args: EndpointPathArgs<TData>
): string;
export function endpoint(url: string, ...args: unknown[]): string {
  if (!url.startsWith(`${CONTRACT_PREFIX}/`)) {
    throw new Error(`endpoint: ${url} is not a contract path (${CONTRACT_PREFIX}/…)`);
  }
  const path = args[0];
  const values = new Map<string, string>();
  if (typeof path === 'object' && path !== null) {
    for (const [key, value] of Object.entries(path)) {
      if (typeof value === 'string' || typeof value === 'number') values.set(key, String(value));
    }
  }
  return url.slice(CONTRACT_PREFIX.length).replace(PLACEHOLDER, (_match, name: string) => {
    const value = values.get(name);
    if (value === undefined) throw new Error(`endpoint: no value for {${name}} in ${url}`);
    return encodeURIComponent(value);
  });
}
